import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { Component, Injector, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@services/entity/users.service';
import { ChargingstationGroupDto } from '../../../dto/chragingstationGroupDto';
import { TableColumn } from '../../../models/tableColumn';
import { TableOptions } from '../../../models/tableOptions';
import { ChargingStationsService } from '../../../services/entity/charging-stations.service';
import { RouteDataService } from '../../../services/route-data/route-data.service';
import { CreateGroupsComponent } from './create-groups/create-groups.component';
import '@angular/localize/init';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'GroupsComponent';

  public entities: ChargingstationGroupDto[];
  public isOperatorView: boolean;

  private customerId: number;

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@GroupsColumn1:Gruppenname`, property: 'name' },
    { columnDescription: $localize`:@@GroupsColumn2:Anzahl Ladestationen`, property: 'countOfChargingStations' },
    { columnDescription: $localize`:@@GroupsColumn3:Beschreibung`, property: 'description'}
  ];

  public tableOptions: TableOptions = {
    showNumbering: true,
    hideActions: true,
    tableStyleClasses: '',
    rowRouterLink: 'edit/{id}'
  };

  constructor(public chargingStationsService: ChargingStationsService, private dialog: NgbModal, injector: Injector, private routeDataService: RouteDataService, public usersService: UsersService) {
    super(chargingStationsService, injector);
  }

  ngOnInit(): void {
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    super.ngOnInit();
  }

  async initializeEntities() {
    if (this.isOperatorView) {
      this.customerId = this.activatedRoute.parent.snapshot.params.key;

      this.chargingStationsService.getChargingstationGroupsOfCustomer(this.customerId).subscribe(result => {
        this.entities = result;
        super.setupTable();
      }, error => {});
    }
    else {
      this.chargingStationsService.getChargingstationGroups().subscribe(result => {
        this.entities = result;
        super.setupTable();
      }, error => {});
    }
  }

  matches(chargingStationGroup: ChargingstationGroupDto, term: string) {
    return chargingStationGroup.name?.toLowerCase().includes(term.toLowerCase()) ||
      chargingStationGroup.countOfChargingStations?.toString().includes(term.toLowerCase()) ||
      chargingStationGroup.description?.toLowerCase().includes(term.toLowerCase());
  }

  openCreateGroupDialog() {
    const dialogRef = this.dialog.open(CreateGroupsComponent, { centered: true, size: 'lg', backdrop: 'static' });

    dialogRef.componentInstance.customerId = this.customerId;

    dialogRef.result.then((result) => {
      this.initializeEntities();
    }, (backdrop) => {
      this.initializeEntities();
    });
  }
}
